import image1 from '../../../assets/images/CommunitySlides/car-show-painting--resized.jpg';
import image2 from '../../../assets/images/CommunitySlides/Dickinson-Students-Shopping-on-Pomfret_20210526_LOH_38--resized.jpg';
import image3 from '../../../assets/images/CommunitySlides/Playa_Bowls_Dickinson_Tour_Guides_20210816_LOH_25--resized.jpg';
import image4 from '../../../assets/images/CommunitySlides/students-walking-festival--resized.jpg';
import image5 from '../../../assets/images/CommunitySlides/love-carlisle-bench--resized.jpg';
import image6 from '../../../assets/images/CommunitySlides/carlisle-theater--resized.jpg';
import image7 from '../../../assets/images/CommunitySlides/volunteer-resized.jpg';


const programs = [
  {img:image1, alt:"Students at Charter Day"},
  {img:image2, alt:"Students at Charter Day"},
  {img:image3, alt:"Students at Charter Day"},
  {img:image4, alt:"Students at Charter Day"},
  {img:image5, alt:"Students at Charter Day"},
  {img:image6, alt:"Students at Charter Day"},
  {img:image7, alt:"Students at Charter Day"},
];

export default programs;
